import { FC } from 'react';
import {
  Category,
  FormPacketFilters,
  FormPacketList,
  useFormPacketSelector,
  type FormV2,
  type PacketV2,
} from '@frontend/form-packet-selector';
import { useSendFormsStore } from '../../../providers';
import { containerStyle, formPacketListContainerStyle } from './select-document.styles';

const SelectDocumentStep: FC = () => {
  const { setFormOrPacketToSend, locationId } = useSendFormsStore(['setFormOrPacketToSend', 'locationId']);
  const { selectorProps } = useFormPacketSelector({
    groupId: locationId,
    onSelect: (item, type) => {
      switch (type) {
        case Category.FORMS: {
          const { id, reviewRequired, name, formPmsId } = item as FormV2;
          setFormOrPacketToSend({
            id: id ?? '',
            type: Category.FORMS,
            reviewRequired: reviewRequired ?? false,
            name: name ?? '',
            isNonEditable: !!formPmsId,
          });
          break;
        }

        case Category.PACKETS: {
          const { id, reviewRequired, name, forms = [] } = item as PacketV2;
          const formIds: string[] = [];

          for (const form of forms) {
            if (form.id) {
              formIds.push(form.id);
            }
          }

          setFormOrPacketToSend({
            id: id ?? '',
            type: Category.PACKETS,
            reviewRequired: reviewRequired ?? false,
            name: name ?? '',
            isNonEditable: false,
            formIds,
          });
          break;
        }
      }
    },
  });

  return (
    <div css={containerStyle}>
      <FormPacketFilters {...selectorProps.formPacketFiltersProps} />
      <div css={formPacketListContainerStyle}>
        <FormPacketList {...selectorProps.formPacketListProps} />
      </div>
    </div>
  );
};

export default SelectDocumentStep;
